








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import dayjs from 'dayjs'

@Component
export default class Today extends Vue {
  time = dayjs().format('ddd YYYY/M/D')
}
